import React from "react";
import {
  Route,
  Routes,
  Navigate,
  HashRouter as Router
} from "react-router-dom";
//import 'bootstrap/dist/css/bootstrap.min.css';

import { ThemeProvider } from '@mui/material/styles';
import Scrollbar from "react-perfect-scrollbar";
import { Theme } from "./theme";

import "react-perfect-scrollbar/dist/css/styles.css";
import GlobalCss from "./styles/jss/GlobalCss";
import LandingGSA from "./home/LandingGSA";
import MaintenancePage from './views/maintenance/MaintenancePage';
import PrivacyPolicy from './views/legal/PrivacyPolicy';


function App() {
  return (
    <ThemeProvider theme={Theme}>
      <GlobalCss>
        <Scrollbar
          className="h-full-screen scrollable-content"
          option={{ suppressScrollX: true }}
        >
          <Router>
            <Routes>
              <Route path="/gsa" element={<LandingGSA />} />
              <Route path="/gsa/maintenance" element={<MaintenancePage />} />
              <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/" element={<Navigate replace to="/gsa" />} />
              {/* <Route component={Error} /> */}
            </Routes>
          </Router>
        </Scrollbar>
      </GlobalCss>
    </ThemeProvider>
  );
}

export default App;
